import { useViewportType } from '@energybox/react-ui-library/dist/hooks';

export const withViewportType = (Component) => (props) => {
  const viewportType = useViewportType();
  return <Component viewportType={viewportType} {...props} />;
};
